import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './successModal.scss'
import { SuccessIcon } from '../../components/Icons';
import { useNavigate } from "react-router-dom";
const SuccessModal = (props) => {

    const navigate = useNavigate();
    const handleToBookinginfo = () =>{
        props.setSuccessModal(false);
       if(props.type === 'moving'){
        navigate('/consumer/job/booking-info/moving', {state: {payload: props.successResponse, sender: props.sender, receiver: props.receiver}})
       }else{
        navigate('/consumer/job/booking-info', {state: {payload: props.successResponse, providerId: props.providerId, serviceName: props?.serviceName, rate: props.rate}})
       }
    }
    return (
        <>
            <Modal show={props.successModal} size="sm" aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header onClick={()=>handleToBookinginfo()} closeButton></Modal.Header>
                <Modal.Body>
                    <div className='success-modal-wrapper'>
                        <div className='icon-wrap'><SuccessIcon /></div>
                        <div className='success-title'>Congratulations</div>
                        <div className='success-message'>Your job request is sent to the provider.</div>
                        <div className='w-100 d-grid success-btn-wrapper'><Button variant='primary' onClick={()=>handleToBookinginfo()}>View Job Details</Button></div>
                    </div>
                </Modal.Body>
            </Modal></>
    )
}

export default SuccessModal